import styled from 'styled-components';

const CompanyName = styled.span`
  display: inline-block;
  margin-left: 12px;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;  
`;

export default CompanyName;
